export function createMadaForm(action, fields = []) {
  const myform = document.createElement("form");
  myform.action = action;
  myform.method = "post";

  fields.forEach(f => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.value = f.fieldValue;
    input.name = f.fieldName;

    myform.appendChild(input)
  })
  document.body.appendChild(myform)
  return myform
}

export function createSmartPayForm(action, fields = []) {
  const myform = document.createElement("form");
  myform.action = action;
  myform.method = "post";

  fields.forEach(f => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.value = f.fieldValue;
    input.name = f.fieldName;

    myform.appendChild(input)
  })
  document.body.appendChild(myform)
  return myform
}


export const StaffFares = [
  'ID00',
  'ID50',
  'ID90'
]

export function hasStaffFare(booking) {
  if(!booking || !Array.isArray(booking.segments)) return false;
  return booking.segments.some(s => Array.isArray(s.fares) && s.fares.some(f => StaffFares.indexOf(f.fareTypeName) >= 0))
}